export default "__VITE_ASSET__YbIxJffd__"